import User from '../user';


import retrieveUser from 'actions/authentication/retrieve';

/**
 * Create the action
 */

const { thunk, request, success, error } = User.update((data, fetch) => {

    // Prepare request
    let formData = new FormData();

    const fields = Object.keys(data);

    fields.map((field) => {
        if(field == 'use_timer' || field == 'finished_onboarding' || field == 'show_hours') {
            return formData.append(field, data[field] ? 1 : 0);
        }

        if(field == 'times') {
            return formData.append(field, JSON.stringify(data[field]));
        }
        formData.append(field, data[field]);
    });

    formData.append('_method', 'PUT');

    return fetch.post(`/users/${data.id}`, formData);
}, {
    onSuccess: function(result, dispatch) {
        
        dispatch(retrieveUser());
    },
    onError: function(error, dispatch) {
        dispatch(retrieveUser());
    },
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
